import { jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import { forwardRef } from 'react';

const TabPanel = forwardRef(({ children, className, value, index, dataTestId, ...props }, ref) => (Number(value) === index ? (jsx("div", { "data-testid": dataTestId || 'tab-panel', role: "tabpanel", ref: ref, className: clsx(className), ...props, children: children })) : null));
TabPanel.displayName = 'TabPanel';

export { TabPanel };
